import { render, staticRenderFns } from "./DispatchTripRow.vue?vue&type=template&id=7fa551f5&scoped=true&"
import script from "./DispatchTripRow.vue?vue&type=script&lang=js&"
export * from "./DispatchTripRow.vue?vue&type=script&lang=js&"
import style0 from "./DispatchTripRow.vue?vue&type=style&index=0&id=7fa551f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa551f5",
  null
  
)

export default component.exports